export default "__VITE_PUBLIC_ASSET__85a77d78__"